import React from 'react'

import { RecipeAttributePill } from 'routes/Menu/components/RecipeAttributePill/RecipeAttributePill'

import { getTagPillIcon } from './getTagPillIcon'

type TagPillProps = {
  type?: string
  text: string
}

export const TagPill = ({ type, text }: TagPillProps) => {
  const pillIcon = getTagPillIcon(type)

  if (!pillIcon) {
    return null
  }

  if (pillIcon.variant === 'local') {
    return <RecipeAttributePill variant="local" localIcon={pillIcon.localIcon} text={text} />
  }

  return <RecipeAttributePill icon={pillIcon.icon} text={text} />
}
